import { DOCUMENT_TYPE } from "./documentTypes";
import get from 'lodash/get';
import Program from "@/models/Program";

const documentTypes: { [id in DOCUMENT_TYPE]: string } = {
    documents_annual_charge: 'Décompte charge et 3 AG',
    documents_notice: 'Notice descriptive',
    documents_notice_pro: 'Notice descriptive Local Pro',
    documents_parking_plan: 'Plan des parkings',
    documents_floor_plan: 'Plan des étages',
    documents_global_plan: 'Doc Contrat Résa',
    documents_booking_contract: 'Plan de masse',
    documents_works_contract: 'Plaquette commerciale',
    documents_commercial_brochure: 'Marché de travaux',
    documents_management_brochure: "Relevé de gérance",
    documents_rental_agreement: 'Bail/relève gérance',
    documents_general_assembly: 'Assemblée générale',
    documents_autres: 'Autres',
};

function checkDocuments(documents: any) {
    let documentsMissing = [];
    for (const key in documentTypes) {
        let isFound = false;
        //@ts-ignore
        documents.forEach(function(value, index) {
            if(value.type && key === value.type) {
                isFound = true;
            }
        });

        if(!isFound && key !== 'documents_autres') {
            documentsMissing.push(get(documentTypes, key, key)); 
        }
    }
    return documentsMissing;
}

function infosMissing(program: Program) {
    let ret = [];
    if(program.duty_free_fee) {
        ret.push('Honoraires');
    }
    return ret;
}


export { checkDocuments, infosMissing };

